<template>
  <div class="upload">
    <div class="upload__header">
      Upload {{files && files.length}} strips
    </div>
    <div class="upload__area" v-if="!files">
      <file-select @select="onFileSelect" :multiple="true" />
    </div>
    <div v-else>
      <div class="upload__toolbar">
        <strip-row>
          <template v-slot:number>Number</template>
          <template v-slot:name>Name</template>
          <template v-slot:publish>
            <select-input
              :options="publishOptions"
              v-model="free"
              v-if="!startUpload"
            />
          </template>
          <template v-slot:date>
            <text-input
              type="date"
              v-model="startDate"
              v-if="!startUpload"
            />
          </template>
          <template v-slot:upload>
            <button :disabled="!files || startUpload" @click="startUpload = true">
              <span v-if="startUpload">
                {{ strips.length }} of {{ uploads.length }} saved
              </span>
              <span v-else>Start Upload</span>
            </button>
          </template>
        </strip-row>
      </div>
      <div class="upload__failed" v-if="failed.length">
        <span>
          <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.86 2.573L1.213 12a1.333 1.333 0 001.14 2h11.294a1.333 1.333
             0 001.14-2L9.14 2.573a1.333 1.333 0 00-2.28 0v0zM8 6v2.667M8 11.333h.007"
              stroke="#FC2222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ failed.length }} {{failed.length === 1 ? 'upload' : 'uploads'}} failed
        </span>
        <a @click="retry">Retry</a>
      </div>
      <div class="upload__list">
        <div class="upload__strip" v-for="upload in uploads" :key="upload.index">
          <upload-strip
            ref="uploads"
            :index="upload.index"
            :file="upload.file"
            :free="upload.free"
            :publishDate="upload.publishDate"
            :upload="startUpload"
            @failed="onFail"
            @uploaded="save"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { database } from '@/firebase';
import { mapActions } from 'vuex';
import { DATEFORMAT } from '@/utilities/time';
import publishOptions from '@/utilities/publishOptions';
import TextInput from '@/components/TextInput.vue';
import SelectInput from '@/components/SelectInput.vue';
import FileSelect from '@/components/FileSelect.vue';
import UploadStrip from './UploadStrip.vue';
import StripRow from './StripRow.vue';

export default {
  name: 'UploadStrips',
  components: {
    TextInput,
    SelectInput,
    FileSelect,
    UploadStrip,
    StripRow,
  },
  data() {
    return {
      startDate: this.closestWeekday(dayjs()).format(DATEFORMAT),
      free: true,
      startUpload: false,
      files: null,
      strips: [],
      failed: [],
      publishOptions,
    };
  },
  computed: {
    dayjs() {
      return dayjs(this.startDate);
    },
    dates() {
      const dates = [];
      let currentDate = this.dayjs;
      this.files.forEach(() => {
        currentDate = this.closestWeekday(currentDate);
        dates.push(currentDate);
        currentDate = currentDate.add(1, 'day');
      });
      return dates;
    },
    uploads() {
      return this.files && this.files.map((file, index) => ({
        index,
        file,
        free: this.free,
        publishDate: this.dates[index].format(DATEFORMAT),
      }));
    },
  },
  methods: {
    ...mapActions(['createStrip']),
    onFileSelect(files) {
      this.files = Object.values(files);
    },
    closestWeekday(dateFn) {
      const isWeekend = [6, 0].includes(dateFn.day());
      if (isWeekend) {
        const isSaturday = dateFn.day() === 6;
        const daysToAdd = isSaturday ? 2 : 1;
        return dateFn.add(daysToAdd, 'days');
      }
      return dateFn;
    },
    save(form) {
      const { getTimestamp } = database;
      const strip = {
        ...form,
        publishDate: getTimestamp(new Date(form.publishDate)),
      };
      this.createStrip(strip).then(() => {
        this.strips.push(strip);
      });
    },
    onFail(index) {
      this.failed.push(index);
    },
    retry() {
      this.failed.forEach((index) => {
        this.$refs.uploads[index].startUpload();
      });
      this.failed = [];
    },
  },
  watch: {
    strips() {
      if (this.strips.length === this.files.length) {
        this.$router.push({
          name: 'ListStrips',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  &__header {
    text-align: center;
    font-weight: 500;
    margin-bottom: 30px;
  }
  &__area {
    max-width: 200px;
    margin: 0 auto;
    padding: 20px 0;
    min-height: calc(100vh - 300px);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__toolbar {
    padding-bottom: 20px;
    border-bottom: solid 1px rgba(0,0,0,0.2);
  }
  &__failed {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  &__list {
    padding: 20px 0;
    width: 100%;
  }
  &__strip {
    margin-bottom: 10px;
  }
}
</style>
